import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_6 = { class: "col p-0" }
const _hoisted_7 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_8 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_9 = { class: "col p-0" }
const _hoisted_10 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_11 = { class: "form-group mb-2 col" }
const _hoisted_12 = { class: "col-auto p-0 text-end" }
const _hoisted_13 = { class: "row m-4 mb-0 mt-0" }
const _hoisted_14 = { class: "col-sm-12" }
const _hoisted_15 = { class: "card card-body mb-0" }
const _hoisted_16 = {
  key: 0,
  class: "text-center text-muted p-4"
}
const _hoisted_17 = {
  key: 1,
  class: "overflow-auto"
}
const _hoisted_18 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_19 = { class: "bg-light" }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-capitalize-first text-end" }
const _hoisted_22 = { class: "text-muted" }
const _hoisted_23 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.fromDate,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromDate) = $event)),
                    mode: "date",
                    "model-modifiers": {string: true},
                    masks: {modelValue: 'YYYY-MM-DD', input: 'YYYY-MM-DD'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.from_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_7)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.toDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toDate) = $event)),
                    mode: "date",
                    "model-modifiers": {string: true},
                    masks: {modelValue: 'YYYY-MM-DD', input: 'YYYY-MM-DD'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.to_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_10)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.load()), ["prevent"])),
                    class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.reset()), ["prevent"])),
                    class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_ctx.loaded && _ctx.items.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.helper.trans('statistic.receiptChecks.empty')), 1))
              : (_ctx.items.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("table", _hoisted_18, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_19, [
                          _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.helper.trans('statistic.receiptChecks.column.trader')), 1),
                          _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.helper.trans('statistic.receiptChecks.column.count')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.traderId
                          }, [
                            _createElementVNode("td", null, [
                              _createTextVNode(_toDisplayString(item.traderName) + " ", 1),
                              _createElementVNode("div", null, [
                                _createElementVNode("small", _hoisted_22, _toDisplayString(item.traderId), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.numberFormatter.formatNumber(item.count)), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}